var map = {
	"./cagayan-cert.webp": 1932,
	"./cert-bg.webp": 1933,
	"./isle-cert.webp": 1934,
	"./license-bg-cn.webp": 1935,
	"./license-bg-mobile-cn.webp": 1936,
	"./license-bg-mobile.webp": 1937,
	"./license-bg.webp": 1938,
	"./pagcor-cert.webp": 1939,
	"./page-bg.webp": 1940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;